import React, { FC, useState, useEffect } from 'react';
import DOMPurify from 'dompurify';

interface FormFieldTooltipProps {
    tooltipText: string;
    tooltipMainIconSource: string;
    tooltipCloseIconSource: string;
    renderTooltipTextAsHtml?: boolean;
}

export const FormFieldTooltip: FC<FormFieldTooltipProps> = ({
    tooltipText,
    tooltipMainIconSource,
    tooltipCloseIconSource,
    renderTooltipTextAsHtml = false,
}) => {
    const [showTooltipText, setShowTooltipText] = useState(false);

    useEffect(() => {
        DOMPurify.addHook('afterSanitizeAttributes', (node: any) => {
            if (node instanceof HTMLElement && 'target' in node) {
                node.setAttribute('target', '_blank');
                node.setAttribute('rel', 'noopener noreferrer');
            }
        });
    }, []);

    return (
        <div className="FormTooltipContainer">
            <div
                className="TooltipIconContainer"
                onClick={() => setShowTooltipText(!showTooltipText)}
            >
                <img
                    src={tooltipMainIconSource}
                    alt="Tooltip clickable icon"
                    className="TooltipMainIcon"
                />
            </div>
            {showTooltipText && (
                <div className="TooltipTextContainer">
                    <img
                        src={tooltipCloseIconSource}
                        alt="Close tooltip"
                        className="TooltipCloseIcon"
                        onClick={() => setShowTooltipText(false)}
                    />
                    {renderTooltipTextAsHtml ? (
                        <div
                            className="Text"
                            dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(tooltipText),
                            }}
                        />
                    ) : (
                        <div className="Text">{tooltipText}</div>
                    )}
                </div>
            )}
        </div>
    );
};
